import React from 'react';

export function ParserLink(content: string) {
    // eslint-disable-next-line max-len
    const urlRegex =
        /((?:https?:\/\/)?(?:www\.[^\s,]+|(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\/([^\s,]+)?)*)(?=\s|,|$))/g;

    const contentSplited = content?.split(urlRegex);
    const contentFormatted = contentSplited?.map((part, index) => {
        if (urlRegex.test(part)) {
            return (
                <a href={part} rel="noreferrer" target="_blank">
                    {part}
                </a>
            );
        }

        return part;
    });

    return contentFormatted;
}
